import { useMemo } from "react"

export type IsCompleted<T> = (item: T) => boolean

export type DashboardStats = {
  total: number
  completedCount: number
  completedPercent: number
  notCompletedPercent: number
  notCompletedCount: number
}

export const useDashboardStats = <T>(
  data: T[],
  isCompleted: IsCompleted<T>
): DashboardStats => {
  const stats = useMemo((): DashboardStats => {
    const total = data.length

    if (!total) {
      return {
        total,
        completedCount: 0,
        completedPercent: 0,
        notCompletedPercent: 0,
        notCompletedCount: 0,
      }
    }

    const completedCount = data.filter(isCompleted).length
    const notCompletedCount = total - completedCount

    return {
      total,
      completedCount,
      notCompletedCount,
      completedPercent: Math.floor((completedCount / total) * 100),
      notCompletedPercent: Math.floor((notCompletedCount / total) * 100),
    }
  }, [data, isCompleted])

  return stats
}
